/**
 * Column template shared by the contacts table header row
 * (`Pages/ContactsList.vue`) and every data row (`ContactsCard.vue`).
 *
 * Both files must lay out on the same track list or the header labels drift
 * away from the values underneath them, so the template lives here rather than
 * being written twice. Tailwind already scans the `components-next` js files,
 * so the utilities below are picked up by JIT.
 */
export const CONTACT_ROW_GRID =
  'grid grid-cols-[minmax(14rem,2fr)_minmax(8rem,1fr)_minmax(8rem,1fr)_minmax(9rem,1fr)_minmax(7rem,1fr)_minmax(7rem,1fr)_2rem] items-center gap-x-4';

export const CONTACT_TABLE_MIN_WIDTH = 'min-w-[60rem]';
